<template lang="pug">
div
  section.section.main-content
    .container
      .header
        h4.title.is-4 Mi equipo
        .button-wrapper
          b-button( v-if="!brokerAdministrator" class="b-button" type="is-primary" @click="createPage") Crear
          b-button( v-if="executiveNationalSupervisor" class="b-button" type="is-link" @click="createPageBroker") Crear Broker
      <b-table :data="data" :columns="columns"></b-table>
</template>
<script>
import { isExecutiveNationalSupervisor } from '@/mixins/user';
import { getBrokerList } from '../services/User/broker';
import { getExecutiveList } from '../services/User/executive';
import { getTechnicalList } from '../services/User/technical';
import { isBrokerAdministrator, isTechnical, isTechnicalNationalSupervisor } from '../mixins/user';
export default {
    name:"Administrator",
    data() {
      return {
        data: [],
        columns: [
          {
              field: 'id',
              label: 'ID',
              width: '40',
              numeric: true
          },
          {
              field: 'first_name',
              label: 'Nombres',
          },
          {
              field: 'last_name',
              label: 'Apellidos',
          },
          {
              field: 'email',
              label: 'Correo',
              centered: true
          },
          {
              field: 'phone',
              label: 'Celular',
          }
        ]
      }
    },
    mounted() {
      isTechnicalNationalSupervisor() ? this.technicalTeamSupervisorList() : null;
      isExecutiveNationalSupervisor() ? this.executiveNationalList() : null;
      isBrokerAdministrator() ? this.brokerOperativeList() : null;
    },

    methods: {
      createPage() {
        this.$router.push({ name:'Create', params: { createExecutive: true } });
      },
      createPageBroker() {
        this.$router.push('/create-broker')
      },
      executiveNationalList() {
        getExecutiveList('team-supervisor').then((result) => {
          this.data = result.data;
        })
      },
      brokerOperativeList() {
        getBrokerList('operative').then((result) => {
          this.data = result.data;
        })
      },
      technicalTeamSupervisorList() {
        getTechnicalList('team-supervisor').then((result) => {
          this.data = result.data;
        })
      }
    },
    computed: {
      executiveNationalSupervisor() {
        return isExecutiveNationalSupervisor();
      },
      brokerAdministrator() {
        return isBrokerAdministrator();
      }
    }
}
</script>
<style lang="scss" scoped>
.title {
  margin-bottom: 0;
}
.header {
  margin-bottom: 26px;
  display: flex;
  justify-content: space-between;
}

.button-wrapper {
  display: flex;
  justify-content: space-between;
  width: 350px;
}
</style>